import { render, staticRenderFns } from "./LoanPaymentBox.vue?vue&type=template&id=c3a6fc00"
import script from "./LoanPaymentBox.vue?vue&type=script&lang=js"
export * from "./LoanPaymentBox.vue?vue&type=script&lang=js"
import style0 from "./LoanPaymentBox.vue?vue&type=style&index=0&id=c3a6fc00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports